import React from 'react';
import { CheckParameter } from '../../../../../utils/security';

const TheadTableManifiesto = ({ auth }) => {
  return (
    <thead className="bg-gray-800 text-white">
      <tr>
        <th className="whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">C. Int</th>
        <th className="whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">C. Cli</th>
        {CheckParameter('PARAMETRO_ID', 2) && <th className="whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">Solicita / Aprueba</th>}
        <th className="min-w-[150px] whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">Descripción</th>
        <th className="min-w-[120px] whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">Tipo servicio</th>
        <th className="min-w-[250px] whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">Vehículo / Personal</th>
        <th className="min-w-[200px] whitespace-nowrap px-3 py-3 text-left text-xs font-semibold uppercase">Origen / Destino</th>
      </tr>
    </thead>
  );
};

export default TheadTableManifiesto;
